import api from './axiosConfig';

export interface HelpTicketDto {
  id: string;
  tenantId: string;
  userId: string | null;
  ticketNumber: string;
  name: string;
  email: string;
  subject: string;
  description: string;
  module: string;
  priority: number;
  status: number;
  tenantName: string | null;
  resolvedBy: string | null;
  resolvedAt: string | null;
  createdAt: string;
}

export interface CreateHelpTicketPayload {
  name: string;
  email: string;
  subject: string;
  description: string;
  module: string;
  priority: number;
}

export interface UpdateHelpTicketStatusPayload {
  id: string;
  status: number;
}

export const helpApi = {
  createTicket: async (data: CreateHelpTicketPayload): Promise<{ id: string }> => {
    const response = await api.post<{ id: string }>('/help/tickets', data);
    return response.data;
  },

  getMyTickets: async (): Promise<HelpTicketDto[]> => {
    const response = await api.get<HelpTicketDto[]>('/help/my-tickets');
    return response.data;
  },

  getTickets: async (params?: {
    tenantId?: string;
    priority?: number;
    status?: number;
    searchTerm?: string;
  }): Promise<HelpTicketDto[]> => {
    const response = await api.get<HelpTicketDto[]>('/help/tickets', { params });
    return response.data;
  },

  updateTicketStatus: async (id: string, data: UpdateHelpTicketStatusPayload): Promise<void> => {
    await api.put(`/help/tickets/${id}/status`, data);
  },
};
